import { STAR_REPORT_MODAL_V1_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV1, type ReportPromoCopyV1 } from "./report-promo-modal-v1"

const COPY: ReportPromoCopyV1 = {
  reportId: ReportIds.Astrology,
  planId: STAR_REPORT_MODAL_V1_PLAN_ID,
  title: "Unlock Star Reading",
  description:
    "Discover what your stars reveal about your personality, timing, relationships, and future path",
}

export function ReportAstrologyModalV1(props: AppModalComponentProps) {
  return <ReportPromoModalV1 {...props} copy={COPY} />
}
